import { useCallback } from "react";
import { apiService } from "../services/apiClient";
import { apiUrl } from "../services/apiUrl";

export const useReportTracking = () => {
  // Log that the current user viewed a report (for analytics)
  const trackReportView = useCallback(async (reportId, userGroupId) => {
    try {
      const response = await apiService.post(apiUrl.aipdTracking(), {
        reportId,
        userGroupId,
      });
      return response.data;
    } catch (err) {
      console.error("Error tracking report view:", err.response?.data?.message || err.message);
      throw err;
    }
  }, []);

  return { trackReportView };
};

export default useReportTracking;
